import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import LogingLogo from '../../images/loging_logo.png'
import { makeStyles, Container, Box, Grid, Card, Button, withStyles } from '@material-ui/core'
import Input from '../../components/abstractObjects/Input';
import AlertDialog from '../../components/abstractObjects/AlertDialog'
import { changeUser } from './user'
import { BasicLabel } from '../../components/abstractObjects/Label'

const textFieldCss = makeStyles({
    root: {
        '& .MuiFormLabel-root': {
            color: '#4db5ff'
        },
        '& .MuiInput-underline': {
            color: '#1861ac'
        },
        marginBottom: '1rem'
    }
})

const BlueButton = withStyles({
    root: {
        color: "white",
        width: "100%",
    },
    disabled: {
        backgroundColor: '#4db5ff !important',
        color: "white !important",
    }
})((props) => <Button {...props} />)

export const ProfileForm = () => {
    const dispatch = useDispatch()
    const classesTextField = textFieldCss()
    const { user } = useSelector(state => state ? state.user : null)

    const [alertMessage, setAlertMessage] = useState({ title: null, message: null })
    const [alertActive, setAlertActive] = useState(false)
    const [oldPassword, setOldPassword] = useState({ value: "", error: null })
    const [newPassword, setNewPassword] = useState({ value: "", error: null })
    const [repeatPassword, setRepeatPassword] = useState({ value: "", error: null })

    const onSetOldPassword = (e) => setOldPassword({ value: e.target.value })
    const onSetNewPassword = (e) => setNewPassword({ value: e.target.value })
    const onSetRepeatPassword = (e) => setRepeatPassword({ value: e.target.value })

    const userChange = async (e) => {
        e.preventDefault()
        if (repeatPassword.value !== newPassword.value) {
            setAlertMessage({ message: "Different passwords have been entered", title: "Error" })
            setAlertActive(true)
            return
        }
        if (oldPassword.value && newPassword.value && oldPassword.value === newPassword.value) {
            setAlertMessage({ message: "The new password cannot match the old one", title: "Error" })
            setAlertActive(true)
            return
        }
        var resultAction = await dispatch(
            changeUser({
                NewPassword: newPassword.value,
                OldPassword: oldPassword.value
            })
        )
        if (resultAction.payload !== undefined && resultAction.payload.Code === 200) {
            setAlertMessage({ message: "User has been changed", type: "success" })
            setOldPassword({ value: "" })
            setNewPassword({ value: "" })
            setRepeatPassword({ value: "" })
        }
        else if (resultAction.payload !== undefined && resultAction.payload.Code === 500) {
            setAlertMessage({ message: resultAction.payload.Message, type: "error" })
            setOldPassword({ value: "" })
            setNewPassword({ value: "" })
            setRepeatPassword({ value: "" })
        }
        else setAlertMessage({ message: "An error occurred, try again", type: "error" })
        setAlertActive(true)
    }

    const canSave = [(oldPassword.value, newPassword.value, repeatPassword.value)].every(Boolean)

    return (<Container maxWidth="md">
        <Box mt="calc(9.5rem - 6%)">
            <Grid>
                <form>
                    <Card className="">
                        <Box p="5px" />
                        <Box mb="1.5rem" px="2rem" align="center" style={{ borderLeft: "5px solid #4db5ff" }}><img style={{ width: "90%" }} src={LogingLogo} alt="logo" /></Box>
                        <Box p="2rem 2rem 1rem 2rem" mb="1rem">
                            <Box>
                                {user.Name}<br /><br />
                                {user.Email}<br /><br />
                            </Box>
                            <Box pb="0.5rem">
                                <Input name="OldPassword" className={classesTextField.root} fullWidth type="password" onChange={onSetOldPassword} value={oldPassword.value} error={oldPassword.error} label="OLD_PASSWORD" />
                            </Box>
                            <Box pb="0.5rem">
                                <Input name="NewPassword" className={classesTextField.root} fullWidth type="password" onChange={onSetNewPassword} value={newPassword.value} error={newPassword.error} label="NEW_PASSWORD" />
                            </Box>
                            <Box pb="0.5rem" mb="2.5rem">
                                <Input name="RepeatPassword" className={classesTextField.root} fullWidth type="password" onChange={onSetRepeatPassword} value={repeatPassword.value} error={repeatPassword.error} label="REPEAT_PASSWORD" />
                            </Box>
                            <BlueButton variant="contained" color="primary" disabled={!canSave} onClick={userChange} type="submit"><BasicLabel text="SAVE_CHANGES" /></BlueButton>
                        </Box>
                    </Card>
                </form>
                <AlertDialog alertActive={alertActive} setAlertActive={setAlertActive} info={alertMessage} />
            </Grid>
        </Box>
    </Container>);
}

export default ProfileForm;